"use strict";

var scrollToTop = function scrollToTop() {
  window.scrollTo(0, 0);
};

module.exports = scrollToTop;